(() => {
  window.dataLayer = window.dataLayer || [];
  document.documentElement.dataset.dorimmAnalytics = "ready";

  const push = (name, detail = {}) => {
    if (!name) return;
    window.dataLayer.push({
      event: name,
      dorimm_path: window.location.pathname,
      dorimm_locale: document.documentElement.lang || "en",
      ...detail,
    });
    document.documentElement.dataset.dorimmLastEvent = name;
  };

  document.addEventListener("dorimm:analytics", (event) => {
    const detail = event.detail || {};
    const { event: name, ...payload } = detail;
    push(name, payload);
  });

  document.addEventListener("click", (event) => {
    const tracked = event.target.closest("[data-analytics-event]");
    if (tracked) push(tracked.dataset.analyticsEvent, { source: tracked.dataset.analyticsSource || "link" });

    const product = event.target.closest("a[href*='/products/']");
    if (product) push("product_view_requested", { target: product.getAttribute("href") });

    const quote = event.target.closest("a[href*='/pages/wheelquote']");
    if (quote && !tracked) push("photo_quote_started", { source: "contextual_link" });

    const checkout = event.target.closest("[name='checkout'],a[href*='/checkout']");
    if (checkout) push("checkout_started", { source: "cart" });
  });

  document.addEventListener("change", (event) => {
    if (event.target.closest("[data-product-option-selectors]")) {
      push("product_configuration_selected", {
        option: event.target.name || event.target.dataset.productOption || "configuration",
        value: event.target.value || "",
      });
    }
  });

  push("dorimm_page_view", {
    template: document.body.dataset.template || "",
  });

  const currentPath = window.location.pathname.replace(/\/$/, "");
  if (
    document.body.classList.contains("page-wheelquote") ||
    currentPath.endsWith("/pages/wheelquote")
  ) {
    push("photo_quote_viewed");
  }
})();
